export class SeoUtil {
	static readonly cannonicalRoutes = ['/', '/placead', '/c/15', '/c/17', '/about', '/privacy-policy', '/help', '/vip', '/cookies-policy', '/terms'];
}
